//import * as Sentry from "@sentry/react"; ^7.120.3

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const reportError = async (error: any): Promise<void> => {
  try {
    //Sentry.captureException(error);
    console.log(error);
  } catch (err) {
    const erro = err as any;
    process.env.NODE_ENV === "development" &&
      console.log(`ERROR --> ${erro.name} -- ${erro.message}`);
  }
};

export const handleError = async (error: Error): Promise<void> => {
  await reportError(error);
};
